import { useEffect } from "react";

export default function useGradientBG() {
  useEffect(() => {
    document.body.classList.add("gradient");
    return () => document.body.classList.remove("gradient");
  }, []);
}
